import React, { useEffect } from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/solid';

interface SuccessMessageProps {
    message: string;
    onClose: () => void;
    duration?: number;
}

const SuccessMessage: React.FC<SuccessMessageProps> = ({ message, onClose, duration = 2000 }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, duration);

        return () => clearTimeout(timer);
    }, [onClose, duration]);

    return (
        <div className="fixed bottom-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex 
            items-center bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded shadow-lg z-50" role="alert">
            <CheckCircleIcon className="w-6 h-6 mr-2" />
            <span className="font-medium">{message}</span>
        </div>
    );
};

export default SuccessMessage;
